import {
  SET_TRANSACTION_TYPES,
  GET_TRANSACTION_DETAIL,
  GET_TRANSACTION_DETAIL_SUCCESS,
  GET_TRANSACTION_DETAIL_FAIL,
  SET_TRANSACTION_QUERY,
  GET_TRANSACTION_BREAKDOWN_SUCCESS,
  GET_TRANSACTION_BREAKDOWN_FAIL,
  GET_TRANSACTION_BREAKDOWN,
  SET_CURRENT_TRANSACTION,
  CLEAR_TRANSACTION_DETAIL,
  SET_SEARCHED_AGENT,
  DOWNLOAD_TRANSACTION_DETAIL,
  DOWNLOAD_TRANSACTION_DETAIL_COMPLETE,
} from "../types/transactionTypes";

const initialState = {
  transactionTypes: [],
  transactions: [],
  loading: false,
  currentTransaction: null,
  downloadingTransaction: false,
  params: {
    agentId: "",
    terminalId: "",
    rrn: "",
    transMode: "",
    pmNumber: "",
    processor: "",
    dateFrom: "",
    dateTo: "",
    number: 1,
    size: 10,
    searchValue: "",
    region: [],
    type: [],
    status: [],
  },
  breakdown: {
    loading: false,
    volume: "0",
    value: "0",
  },
  //Admin Agent Search
  searchedAgent: undefined,
};

const transactionsReducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case SET_TRANSACTION_TYPES:
      return {
        ...state,
        transactionTypes: payload,
      };

    case GET_TRANSACTION_DETAIL:
      return {
        ...state,
        loading: true,
      };

    case GET_TRANSACTION_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        transactions: payload,
      };
    case GET_TRANSACTION_DETAIL_FAIL:
      return {
        ...state,
        loading: false,
      };

    case CLEAR_TRANSACTION_DETAIL:
      return {
        ...state,
        transaction: [],
      };
    case SET_TRANSACTION_QUERY:
      let newParams = { ...state.params };
      newParams[payload.name] = payload.value;
      return {
        ...state,
        params: newParams,
      };

    case SET_CURRENT_TRANSACTION:
      return {
        ...state,
        currentTransaction: payload,
      };

    case GET_TRANSACTION_BREAKDOWN_SUCCESS:
      return {
        ...state,
        breakdown: {
          ...state.breakdown,
          loading: false,
          volume: payload.data?.totalVolume,
          value: payload.data?.totalValue,
        },
      };

    case GET_TRANSACTION_BREAKDOWN_FAIL:
      return {
        ...state,
        breakdown: {
          ...state.breakdown,
          loading: false,
        },
      };

    case GET_TRANSACTION_BREAKDOWN:
      return {
        ...state,
        breakdown: {
          ...state.breakdown,
          loading: true,
        },
      };

    case DOWNLOAD_TRANSACTION_DETAIL:
      return {
        ...state,
        downloadingTransaction: true,
      };

    case DOWNLOAD_TRANSACTION_DETAIL_COMPLETE:
      return {
        ...state,
        downloadingTransaction: false,
      };

    case SET_SEARCHED_AGENT:
      return {
        ...state,
        searchedAgent: payload,
      };
    default:
      return state;
  }
};

export default transactionsReducer;
